import { Injectable } from '@angular/core';
import { WebService } from './web.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormsApiService {

  constructor(
    private http: HttpClient,
    private web: WebService
  ) { }

  async getFormResponses(tenantId?: string, formId?: string): Promise<any> {
    const tenant = tenantId ?? 'e875b9bb-b3ee-4961-b756-3aad14e43814'
    const form = formId ?? 'u7l16O6zYUm3VjqtFOQ4FPjo0VF0xjhCrr_LxcSLFXJUMkg4ODBGOVBLS0tRRVFFNEROOU9ENlBQQS4u'
    const token = localStorage.getItem('forms_authToken');
    if (!token) throw new Error('No access token');

    const params = [{ value: tenant, name: 'tenantId' }, {value: form, name: 'formId'}]
    const headers = [{ name: 'Authorization', value: `Bearer ${token}` }]

    const result = lastValueFrom(this.web.getWebCall('formapi', 'forms', {params: params, headers: headers}))

    //const result =  firstValueFrom(
    //  this.http.get(`/api/v1/formapi/forms/${tenant}/${form}/responses`, { headers })
    //);
    console.log(result)
  }

}
